<template>
  <div>
    <div class="headline pb-4">
      Подключить функцию:
      <div class="headline mt-2">{{ `${functionName.name}` }}?</div>
    </div>
    <div class="d-flex subtitle-1 py-2">
      <div class="flex-none">Абонентская плата</div>
      <div class="mx-2 dashed"></div>
      <div class="flex-none">{{ `${functionName.abonpay} ₽/мес` }}</div>
    </div>
    <div class="d-flex pt-2 mt-4">
      <v-btn @click="sendToChange" class="primary mx-0">
        Оставить заявку менеджеру
      </v-btn>
      <div class="valign-middle text-sm-right align-self-center ml-3">
        <button
          @click="cancel"
          type="button"
          class="subtitle-1 font-weight-medium"
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
        >
          <span class="dashed dashed--2">
            Отменить
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";

export default {
  name: "tariffFunctionChangeConfirm",
  props: {
    // id функции
    funcId: {
      type: String,
      required: true
    },
    // id тарифа
    tarifId: {
      type: String,
      required: true
    },
    serviceId: {
      type: Number,
      required: true
    }
  },
  computed: {
    // объект с данными по тарифн
    tariff() {
      return this.$store.getters.tariffList.find(
        item => item.id === this.tarifId
      );
    },
    // имя функции в тарифе
    functionName() {
      return this.tariff.functions.find(item => item.id === this.funcId);
    }
  },
  methods: {
    // отмена
    cancel() {
      this.$emit("closeDialog");
    },
    // заявка на подключение определенной функции
    sendToChange() {
      const funcDescr = `
      ${this.functionName.name} за ${this.functionName.abonpay} ₽/мес.`;
      RequestApi.sendToChangeTariffFunction({
        funcId: this.funcId,
        funcDescr: funcDescr,
        serviceId: this.serviceId
      })
        .then(() => {
          // открываем сообщение
          this.$store
            .dispatch("popupInfoOpen", {
              timeout: 3000,
              text: "Заявка успешно отправлена"
            })
            .then(() => {
              this.$emit("closeDialog");
            });
        })
        .catch(err => {
          this.error = err;
        });
    }
  }
};
</script>
